import TagManager from 'react-gtm-module';
import { GtmEventParams } from '@monorepo/client-types';
import { AnalyticsEventTypes } from '@monorepo/types';

export interface AnalyticsParams {
  title: string;
  location: string;
  [key: string]: any;
}

export interface AnalyticsService {
  sendEvent(data: {
    event: AnalyticsEventTypes;
    params: AnalyticsParams;
  }): void;
}

class GTMService {
  private gtmInitialized = false;

  initialize(gtmId: string) {
    try {
      const tagManagerArgs = {
        gtmId,
      };

      TagManager.initialize(tagManagerArgs);

      this.gtmInitialized = true;
    } catch (e) {
      console.error(e);
    }
  }

  sendEvent(eventParams: GtmEventParams) {
    if (!this.gtmInitialized) {
      console.error('GTM is not initialized');

      return;
    }
    return window.dataLayer.push({
      event: eventParams.event,
      ...eventParams.params,
    });
  }
}
const gtmService = new GTMService();

export default gtmService;
